import { createContext } from 'react';
import { EntityValue } from '../entities/entity-value';
export var defaultEntityTypeValuesSet = {
  Entity: EntityValue
};
export var EntityTypeValuesContext = createContext(defaultEntityTypeValuesSet);
export var EntityTypeValuesProvider = EntityTypeValuesContext.Provider;